<template>
  <div class="hc-login">
    <h1 class="title">{{ title }}</h1>
    <p class="text">金航-机器人设备后台管理系统</p>
  </div>

  <div style="margin-top: 50px">
    <el-form
      ref="formRef"
      :rules="rules"
      :label-position="labelPosition"
      :model="formLabelAlign"
      :size="size"
      style="width: 500px"
    >
      <el-form-item label="手机号码" prop="name">
        <el-input
          :prefix-icon="User"
          v-model="formLabelAlign.name"
          placeholder="请输入手机号"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item label="验证码" prop="emil" class="reatvie">
        <el-input
          :prefix-icon="Message"
          v-model="formLabelAlign.emil"
          placeholder="请输入验证码"
          autocomplete="off"
        />
        <span
          class="emil"
          :class="{ disabled: countdown > 0 }"
          @click="sendCode"
        >
          {{ countdown > 0 ? `${countdown}s 后重新发送` : "发送验证码" }}
        </span>
      </el-form-item>
      <el-form-item label="账户密码" prop="passwrod">
        <el-input
          :prefix-icon="Lock"
          v-model="formLabelAlign.passwrod"
          placeholder="请输入密码"
          autocomplete="off"
          type="password"
        />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPsd">
        <el-input
          type="password"
          :prefix-icon="Lock"
          v-model="formLabelAlign.confirmPsd"
          placeholder="请再次输入密码"
          autocomplete="off"
        />
      </el-form-item>
    </el-form>

    <div class="btn">
      <el-button class="btn_t" :loading="loading" @click="register(formRef)" type="primary">{{
        btnType == 0 ? "注册" : "修改密码"
      }}</el-button>
    </div>
    <div class="txt" @click="emit('login')">已有帐号？点击去登录</div>
  </div>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, onBeforeUnmount } from "vue";
import { User, Lock, Message } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";

const emit = defineEmits(["login"]);
const props = defineProps({
  title: {
    type: String,
    default: "注册",
  },
  btnType: {
    type: Number,
    default: 0,
  },
});

const route = useRoute();
const router = useRouter();
const labelPosition = ref("top");
const size = ref("large");
const formRef = ref(null);
const loading = ref(false);

const countdown = ref(0);
let timer = null;

const sendCode = () => {
  if (countdown.value > 0) return;
  
  if (!formLabelAlign.name) {
    ElMessage.warning("请先输入手机号码");
    return;
  }
  if (!/^1[3-9]\d{9}$/.test(formLabelAlign.name)) {
    ElMessage.warning("请输入正确的手机号码");
    return;
  }

  ElMessage.success("验证码已发送，请注意查收");
  countdown.value = 60;
  timer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      clearInterval(timer);
    }
  }, 1000);
};

const validateConfirmPsd = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请再次输入密码"));
  } else if (value !== formLabelAlign.passwrod) {
    callback(new Error("两次输入密码不一致!"));
  } else {
    callback();
  }
};

const rules = reactive({
  emil: [
    {
      required: true,
      message: "验证码不能为空",
      trigger: "blur",
    },
  ],
  name: [
    {
      required: true,
      message: "手机号码不能为空",
      trigger: "blur",
    },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入正确的手机号码",
      trigger: "blur",
    },
  ],
  passwrod: [
    {
      required: true,
      message: "密码不能为空",
      trigger: "blur",
    },
  ],
  confirmPsd: [
    {
      required: true,
      validator: validateConfirmPsd,
      trigger: "blur",
    },
  ],
});

const formLabelAlign = reactive({
  emil: "",
  name: "",
  passwrod: "",
  confirmPsd: "",
});

const register = (formEl) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      loading.value = true;
      // Mock request simulation
      setTimeout(() => {
        loading.value = false;
        ElMessage.success(props.btnType === 0 ? "注册成功" : "修改密码成功");
        emit("login");
      }, 1000);
    } else {
      ElMessage.warning("请填写完整的表单信息");
    }
  });
};

onBeforeUnmount(() => {
  if (timer) clearInterval(timer);
});
</script>

<style lang="less" scoped>
.reatvie {
  position: relative;
}

.emil {
  color: #1e6aed;
  cursor: pointer;
  position: absolute;
  right: 10px;
  user-select: none;
  &.disabled {
    color: #999999;
    cursor: not-allowed;
  }
}

.ore {
  font-size: 14px;
  cursor: pointer;
  color: #1e6aed;
}

.title {
  color: #1a1a1a;
  margin-bottom: 5px;
}

.text {
  color: #999999;
  font-size: 16px;
}

/deep/.el-form-item__label {
  font-size: 16px;
  color: #1a1a1a;
}

.btn {
  width: 100%;
  margin-top: 60px;
}

.btn_t {
  height: 50px;
  width: 100%;
  background-color: #1e6aed;
  font-size: 16px;
}

.txt {
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
  cursor: pointer;
  color: #1e6aed;
}
</style>
